import { Statuses } from '@wix/domains-search-suite';
import { MobileConnectOnDesktop } from '../../Components/StatusesOverrides/LoggedInMobile/MobileConnectOnDesktop';
export const mobileUpgradeRequireAssignStatus = props => ({
  ...Statuses.upgradeRequireAssign(props),
  StatusComponent: MobileConnectOnDesktop,
  autoInvoke: false
});
//# sourceMappingURL=mobileUpgradeAssignStatus.js.map